/* ==============================================
   SEO — the one place a route's title, description
   and canonical URL are described.

   src/seo/routes.json is the manifest. It is JSON
   rather than JS for one reason: the build scripts
   (scripts/build-seo.mjs, scripts/prerender.mjs)
   read the same file the app renders from, so the
   sitemap, the prerendered HTML and the <head> the
   browser sees cannot drift apart.

   Titles are held under 60 characters and
   descriptions under 155 so neither truncates in a
   search result — scripts/build-seo.mjs fails the
   build if an entry breaks either limit.

   To add a route:
     1. Add the <Route> in src/App.js.
     2. Add an entry to routes.json. Set
        "index": false for anything that shouldn't
        be in Google (utility and thank-you pages).
     3. Drop <Seo path="/the-path" /> at the top of
        the page component.
   The sitemap picks it up on the next build.
   ============================================== */

import manifest from "./routes.json";

export const SITE = manifest.site;
export const ROUTES = manifest.routes;
export const REDIRECTS = manifest.redirects;

/* A section that moved with everything beneath it: /resources/<slug> has to
   land on /insights/<slug>, not just /resources on /insights. Exact pairs
   above can't express that, and the article URLs are the indexed ones. */
export const REDIRECT_PREFIXES = manifest.redirectPrefixes || [];

/* Indexable routes only — what the sitemap lists and what the prerenderer
   is expected to produce real HTML for. */
export const indexableRoutes = ROUTES.filter((r) => r.index);

export const routeFor = (path) => ROUTES.find((r) => r.path === path);

/* Canonicals are absolute and self-referencing. The trailing slash is kept
   on the homepage and dropped everywhere else, which is the shape Google
   treats as canonical for a site whose links are written that way. */
export const absoluteUrl = (path = "/") => {
  if (/^https?:\/\//i.test(path)) return path;
  const clean = path === "/" ? "/" : `/${path.replace(/^\/+|\/+$/g, "")}`;
  return `${SITE.origin}${clean}`;
};

export default manifest;
